/**
 * Checks Form validity and sets error class
 */
export default class FormValidator {
  /**
   * constructor
   * @param {Object} [config] - optional/additional parameters
   */
  constructor(config = {}) {
    this.config = {
      modifier: {
        invalid: 'form__form-tag--invalid',
      },
      ignoreList: [
        '.search__form',
      ],
      ...config,
    };
    const ignoreList = this.config.ignoreList.map((entry) => `:not(${entry})`).join('');
    this.forms = document.querySelectorAll(`form${ignoreList}`);
    if (!this.forms.length) {
      return;
    }
    this.bindEvents();
  }

  /**
   * binds listener to forms and disables html5 validation first
   */
  bindEvents() {
    this.forms.forEach((form) => {
      // eslint-disable-next-line no-param-reassign
      form.noValidate = true;
      form.addEventListener('submit', (event) => {
        this.handleForm(event);
      });
    });
  }

  /**
   * switches modifier classs for valid/invalid form,
   * prevents submit if not valid and reports the validity.
   * @param {Event} event - submit event
   */
  handleForm(event) {
    const { target } = event;
    if (target.checkValidity()) {
      target.classList.remove(this.config.modifier.invalid);
    } else {
      target.classList.add(this.config.modifier.invalid);
      event.preventDefault();
      target.reportValidity();
    }
  }
}
